'use client'

import { useEffect } from 'react'

import { AUTH_LOGOUT_PATH } from '../../const/auth-logout-path.const'
import { useSessionStore } from '../../stores'

import styles from './LogoutClient.module.scss'

export function LogoutClient() {
  // Effects
  useEffect(() => {
    // Clear session token on logout
    useSessionStore.getState().clearToken()
    window.location.href = AUTH_LOGOUT_PATH
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1>Signing out...</h1>
        <p>You are being redirected to the login page.</p>
      </div>
    </div>
  )
}
